import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import axios from 'axios';
import { getPreferredLanguage, normalizeLanguageCode, setApiLanguageHeader } from './utils/language';

const PUBLIC_URL = (process.env.PUBLIC_URL || '').replace(/\/$/, '');

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'pt',
    lng: getPreferredLanguage(),
    supportedLngs: ['en', 'pt'],
    nonExplicitSupportedLngs: true, 
    load: 'languageOnly',       
    lowerCaseLng: true,
    debug: process.env.NODE_ENV !== 'production',
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: `${PUBLIC_URL}/locales/{{lng}}/translation.json`,
    },
    detection: {
      //consider <html lang=".."> when present
      order: ['localStorage', 'cookie', 'htmlTag', 'navigator'],
      caches: ['localStorage', 'cookie'],
      lookupLocalStorage: 'i18nextLng',
    },
    react: {
      useSuspense: false,
    },
  });

i18n.on('languageChanged', (language) => {
  const normalizedLanguage = normalizeLanguageCode(language);
  document.documentElement.lang = normalizedLanguage;
  setApiLanguageHeader(normalizedLanguage);
});

const initialLanguage = normalizeLanguageCode(i18n.language || getPreferredLanguage());
document.documentElement.lang = initialLanguage;
setApiLanguageHeader(initialLanguage);
axios.defaults.headers.common['Accept-Language'] = initialLanguage;

export default i18n;
